import React, { useState, useEffect } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";



const AddItemPopup = ({ globalContext }) => {

    const [addTitle, setAddTitle] = useState("");
    const [errorAddTitle, setErrorAddTitle] = useState(false);
    const [isAddingTechDoc, setIsAddingTechDoc] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [templates, setTemplates] = useState([]);
    const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);

    const AppContext = globalContext;

    

    useEffect(() => {

        loadTemplates();

    }, []);


    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const loadTemplates = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Templates/";

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingTemplates(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setTemplates(data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoadingTemplates(false);
            });

    }



    const addTechDoc = () => {
        
        let newItem = {
            Id: 0,
            Name: addTitle,
            TemplateId: selectedTemplateId
        };
        

        let isValidForm = true;

        setErrorAddTitle(false);

        if (!validFormField(addTitle, setErrorAddTitle))
            isValidForm = false;
        
        if (!isValidForm) return false;



        let url = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };


        setIsAddingTechDoc(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingTechDoc(false);
            });


    }








    





    return (
        <div className="add-task-popup">


            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>


            <div>
                <input className={`form-field-text add-task-field-name ${errorAddTitle ? " form-field-error" : null}`}
                    value={addTitle}
                    onChange={(e) => setAddTitle(e.target.value)}
                    style={{ width: "100%" }} type="text" placeholder="Technical Documentation Reference & Title *" />

                {errorAddTitle && (
                    <span className="form-field-error-message">
                        This field is necessary
                    </span>
                )}
            </div>


            <div style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>

                <div style={{marginRight: "5px"}}>
                    Use this template for default structure:
                </div>

                <div>
                    {isLoadingTemplates ? <LoadingSpinnerImage /> : 
            
                        <select value={selectedTemplateId} onChange={(e) => setSelectedTemplateId(e.target.value)}>
                            <option value="">- empty structure -</option>
                            {templates.map(template => {
                                return <option value={template.Id}>{template.Title}{template.IsMedboard ? " [Medboard]" : ""}</option>
                            })}
                        </select>
                    }
                </div>

            </div>




            <br />
            <div className="action-button-bar">

                <div className="action-button-bar-left">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Close
                    </button>
                </div>
                <div className="action-button-bar-center">

                </div>

                <div className="action-button-bar-right">
                    {isAddingTechDoc ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                                onClick={addTechDoc}
                        >
                            Add Technical Documentation
                        </button>
                    )}
                </div>
            </div>



            <br />

        </div>
    );
};








export default AddItemPopup;